import {defineMessages} from "@project/i18n";

export const expedientFieldLabelIds = {
  alias: "fields.expedient.alias",
  classification: "fields.expedient.classification",
  country: "fields.expedient.country",
  description: "fields.expedient.description",
  location: "fields.expedient.location",
  name: "fields.expedient.name",
  standard: "fields.expedient.standard",
} as const;

export const expedientFieldMessages = defineMessages({
  alias: {
    id: "fields.expedient.alias",
    defaultMessage: "Alias",
    description: "Expedient field label for alias",
  },
  classification: {
    id: "fields.expedient.classification",
    defaultMessage: "Classification",
    description: "Expedient field label for classification",
  },
  country: {
    id: "fields.expedient.country",
    defaultMessage: "Country",
    description: "Expedient field label for country",
  },
  description: {
    id: "fields.expedient.description",
    defaultMessage: "Description",
    description: "Expedient field label for description",
  },
  location: {
    id: "fields.expedient.location",
    defaultMessage: "Location",
    description: "Expedient field label for location",
  },
  name: {
    id: "fields.expedient.name",
    defaultMessage: "Name",
    description: "Expedient field label for name",
  },
  standard: {
    id: "fields.expedient.standard",
    defaultMessage: "Standard",
    description: "Expedient field label for standard",
  },
});

export const expedientValidationMessages = defineMessages({
  standardUnique: {
    id: "validation.expedient.standardUnique",
    defaultMessage: "Standards must be unique.",
    description: "Reject repeated standards in an Expedient specification",
  },
  equipmentOptionName: {
    id: "validation.expedient.equipmentOptionName",
    defaultMessage: "Use a nonblank additional option name that does not shadow a fixed option.",
    description: "Reject blank or reserved additional equipment names",
  },
});
